/*!
 * classie - class helper functions
 * from bonzo https://github.com/ded/bonzo
 * 
 * classie.has( elem, 'my-class' ) -> true/false
 * classie.add( elem, 'my-new-class' )
 * classie.remove( elem, 'my-unwanted-class' )
 * classie.toggle( elem, 'my-class' )
 */

/*jshint browser: true, strict: true, undef: true */
/*global define: false */

(function (window) {

    'use strict';

    // class helper functions from bonzo https://github.com/ded/bonzo

    function classReg(className) {
        return new RegExp("(^|\\s+)" + className + "(\\s+|$)");
    }

    // classList support for class management
    // altho to be fair, the api sucks because it won't accept multiple classes at once
    var hasClass, addClass, removeClass;

    if ('classList' in document.documentElement) {
        hasClass = function (elem, c) {
            return elem.classList.contains(c);
        };
        addClass = function (elem, c) {
            elem.classList.add(c);
        };
        removeClass = function (elem, c) {
            elem.classList.remove(c);
        };
    }
    else {
        hasClass = function (elem, c) {
            return classReg(c).test(elem.className);
        };
        addClass = function (elem, c) {
            if (!hasClass(elem, c)) {
                elem.className = elem.className + ' ' + c;
            }
        };
        removeClass = function (elem, c) {
            elem.className = elem.className.replace(classReg(c), ' ');
        };
    }

    function toggleClass(elem, c) {
        var fn = hasClass(elem, c) ? removeClass : addClass;
        fn(elem, c);
    }

    var classie = {
        // full names
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        toggleClass: toggleClass,
        // short names
        has: hasClass,
        add: addClass,
        remove: removeClass,
        toggle: toggleClass
    };

    // transport
    if (typeof define === 'function' && define.amd) {
        // AMD
        define(classie);
    } else {
        // browser global
        window.classie = classie;
    }

})(window);

/**
 * Based on selectFx.js v1.0.0
 * http://www.codrops.com
 */
; (function (window) {

    'use strict';

    /**
	 * based on from https://github.com/inuyaksa/jquery.nicescroll/blob/master/jquery.nicescroll.js
	 */
    function hasParent(e, p) {
        if (!e) return false;
        var el = e.target || e.srcElement || e || false;
        while (el && el != p) {
            el = el.parentNode || false;
        }
        return (el !== false);
    };

    /**
	 * extend obj function
	 */
    function extend(a, b) {
        for (var key in b) {
            if (b.hasOwnProperty(key)) {
                a[key] = b[key];
            }
        }
        return a;
    }

    /**
	 * SelectFx function
	 */
    function SelectFx(el, options) {
        this.el = el;
        this.options = extend({}, this.options);
        extend(this.options, options);
        this._init();
    }

    /**
	 * SelectFx options
	 */
    SelectFx.prototype.options = {
        // if true all the links will open in a new tab.
        // if we want to be redirected when we click an option, we need to define a data-link attr on the option of the native select element
        newTab: false,
        // when opening the select element, the default placeholder (if any) is shown
        stickyPlaceholder: true,
        // callback when changing the value
        onChange: function (val) { return false; }
    }

    /**
	 * init function
	 * initialize and cache some vars
	 */
    SelectFx.prototype._init = function () {
        // check if we are using a placeholder for the native select box
        // we assume the placeholder is disabled and selected by default
        var selectedOpt = this.el.querySelector('option[selected]');
        this.hasDefaultPlaceholder = selectedOpt && selectedOpt.disabled;

        // get selected option (either the first option with attr selected or just the first option)
        this.selectedOpt = selectedOpt || this.el.querySelector('option');

        // create structure
        this._createSelectEl();

        // all options
        this.selOpts = [].slice.call(this.selEl.querySelectorAll('li[data-option]'));

        // total options
        this.selOptsCount = this.selOpts.length;

        // current index
        this.current = this.selOpts.indexOf(this.selEl.querySelector('li.cs-selected')) || -1;

        // placeholder elem
        this.selPlaceholder = this.selEl.querySelector('span.cs-placeholder');

        // details elem
        this.selDetails = this.selEl.querySelector('span.cs-details');

        // init events
        this._initEvents();
    }

    /**
	 * creates the structure for the select element
	 */
    SelectFx.prototype._createSelectEl = function () {
        var self = this, options = '', createOptionHTML = function (el) {
            var optclass = '', classes = '', link = '';

            if (el.selectedOpt && !this.foundSelected && !this.hasDefaultPlaceholder) {
                classes += 'cs-selected ';
                this.foundSelected = true;
            }
            // extra classes
            if (el.getAttribute('data-class')) {
                classes += el.getAttribute('data-class');
            }
            // link options
            if (el.getAttribute('data-link')) {
                link = 'data-link=' + el.getAttribute('data-link');
            }

            var price = '', moneysign = '', calories = '', calorieword = '', isMainList = '', isMainListData = '';
            var dataPrice = '', dataMoneySign = '', dataCalories = '', dataCalorieWord = '';
            var dataProductId = '', dataProductClassId = '', dataOptionId = '', dataOptionValue = '', dataCookieFlavorId = '';

            if (el.getAttribute('data-submit-option-id')) {
                dataOptionId = 'data-submit-option-id="' + el.getAttribute('data-submit-option-id') + '" ';
            }

            if (el.getAttribute('data-submit-option-value')) {
                dataOptionValue = 'data-submit-option-value="' + el.getAttribute('data-submit-option-value') + '" ';
            }

            if (el.getAttribute('data-submit-product-id')) {
                dataProductId = 'data-submit-product-id="' + el.getAttribute('data-submit-product-id') + '" ';
            }

            if (el.getAttribute('data-submit-product-class-id')) {
                dataProductClassId = 'data-submit-product-class-id="' + el.getAttribute('data-submit-product-class-id') + '" ';
            }
            if (el.getAttribute('data-submit-cookie-flavor-id')) {
                dataCookieFlavorId = 'data-submit-cookie-flavor-id="' + el.getAttribute('data-submit-cookie-flavor-id') + '" ';
            }

            // if there is a price defined
            if (el.getAttribute('data-price')) {
                dataPrice = 'data-price="' + el.getAttribute('data-price') + '" ';
                price = el.getAttribute('data-price');
            }
            // if there is a isMainList defined
            if (el.getAttribute('data-is-main-list')) {
                var isMainListData = 'data-is-main-list=' + el.getAttribute('data-is-main-list');
                var isMainList = el.getAttribute('data-is-main-list');
            }

            // if there is a monetary symbol defined
            if (el.getAttribute('data-moneysign')) {
                dataMoneySign = 'data-moneysign="' + el.getAttribute('data-moneysign') + '" ';
                moneysign = el.getAttribute('data-moneysign');
            }

            // if there are calories defined
            if (el.getAttribute('data-calories')) {
                dataCalories = 'data-calories="' + el.getAttribute('data-calories') + '" ';
                calories = el.getAttribute('data-calories');
            }

            // if there is a word for "calories" defined
            if (el.getAttribute('data-calorieword')) {
                dataCalorieWord = 'data-calorieword="' + el.getAttribute('data-calorieword') + '" ';
                calorieword = el.getAttribute('data-calorieword');
            }


            if (classes !== '') {
                optclass = 'class="' + classes + '" ';
            }

            if (!price) {
                moneysign = '';
            }

            var calorieElement = '';
            if (calories) {
                calorieElement = '<span class="item-calories">' + calories + '<div class="cal">' + calorieword + '</div></span>';
            }
            if ($('html').attr('lang') == "fr-CA") {

                return '<li tabindex="-1" role="option" id="' + el.getAttribute('data-submit-option-value') + '" aria-label="' + el.value + ' ' + moneysign + ' ' + price + ' ' + calories + ' ' + calorieword + '" ' + optclass + link
                    + dataPrice + ' ' + dataCalories + ' ' + isMainListData + ' data-option data-value="' + el.value + '" ' + dataOptionId + dataOptionValue + dataProductId + dataProductClassId + dataCookieFlavorId + '><span class="item-name">'
                    + el.textContent + ' ' + '</span>' + '<span class="item-price">' + price.replace(".",",") + moneysign + ' ' + '</span>' + calorieElement + '</li>';
            }
            else {
                return '<li tabindex="-1" role="option" id="' + el.getAttribute('data-submit-option-value') + '" aria-label="' + el.value + ' ' + moneysign + ' ' + price + ' ' + calories + ' ' + calorieword + '" ' + optclass + link
                    + dataPrice + ' ' + dataCalories + ' ' + isMainListData + ' data-option data-value="' + el.value + '" ' + dataOptionId + dataOptionValue + dataProductId + dataProductClassId + dataCookieFlavorId + '><span class="item-name">'
                    + el.textContent + ' ' + '</span>' + '<span class="item-price">' + moneysign + price + ' ' + '</span>' + calorieElement + '</li>';
            }
        };

        [].slice.call(this.el.children).forEach(function (el) {
            if (el.disabled) { return; }

            var tag = el.tagName.toLowerCase();

            if (tag === 'option') {
                options += createOptionHTML(el);
            }
            else if (tag === 'optgroup') {
                options += '<li class="cs-optgroup"><span>' + el.label + '</span><ul>';
                [].slice.call(el.children).forEach(function (opt) {
                    options += createOptionHTML(opt);
                })
                options += '</ul></li>';
            }
        });

        var opts_el = '<div class="cs-options" ><ul role="listbox">' + options + '</ul></div>';
        this.selEl = document.createElement('div');
        this.selEl.className = this.el.className;

        this.selEl.setAttribute("aria-label", this.selectedOpt.textContent);
        this.selEl.innerHTML = '<span role="button" aria-haspopup="listbox" aria-expanded="false" class="cs-placeholder" tabindex="0">' + this.selectedOpt.textContent + '</span>' + opts_el;
        this.el.parentNode.appendChild(this.selEl);
        this.selEl.appendChild(this.el);

    }


    /**
	 * initialize the events
	 */
    SelectFx.prototype._initEvents = function () {
        var self = this;

        // open/close select
        this.selEl.addEventListener('click', function (evt) {
            self._toggleSelect();
        });

        


        // clicking the options
        this.selOpts.forEach(function (opt, idx) {            
            opt.addEventListener('click', function (evt) {
                self.current = idx;
                self._changeOption(true);
                self._toggleSelect();
                evt.stopImmediatePropagation();
                // close select elem
            });
        });

        // close the select element if the target it´s not the select element or one of its descendants..
        document.addEventListener('click', function (ev) {
            var target = ev.target;
            if (self._isOpen() && target !== self.selEl && !hasParent(target, self.selEl)) {                
                self._toggleSelect();
            }
        });

        // keyboard navigation events
        this.selEl.addEventListener('keydown', function (ev) {
            var keyCode = ev.keyCode || ev.which;

            switch (keyCode) {
                // up key
                case 38:
                    ev.preventDefault();
                    self._navigateOpts('prev');
                    break;
                // down key
                case 40:
                    ev.preventDefault();
                    self._navigateOpts('next');
                    break;
                // space key
                case 32:
                    ev.preventDefault();
                    if (self._isOpen() && typeof self.preSelCurrent != 'undefined' && self.preSelCurrent !== -1) {
                        self._changeOption(false);
                    }
                    self._toggleSelect();
                    break;
                // tab key
                case 9:
                    if (self._isOpen()) {
                        self._toggleSelect();
                    }
                    break;
                // enter key
                case 13:
                    ev.preventDefault();
                    if (self._isOpen() && typeof self.preSelCurrent != 'undefined' && self.preSelCurrent !== -1) {
                        self._changeOption(false);
                        self._toggleSelect();
                    } else if (!self._isOpen()) {
                        self._toggleSelect();
                    }
                    break;
                // esc key
                case 27:
                    ev.preventDefault();
                    if (self._isOpen()) {
                        self._toggleSelect();
                    }
                    break;
            }
        });
    }
      
    /**
	 * navigate with up/dpwn keys
	 */
    SelectFx.prototype._navigateOpts = function (dir) {
        if (!this._isOpen()) {
            this._toggleSelect();
        }

        var tmpcurrent = typeof this.preSelCurrent != 'undefined' && this.preSelCurrent !== -1 ? this.preSelCurrent : this.current;

        if (dir === 'prev' && tmpcurrent > 0 || dir === 'next' && tmpcurrent < this.selOptsCount - 1) {

            // save pre selected current - if we click on option, or press enter, or press space this is going to be the index of the current option
            this.preSelCurrent = dir === 'next' ? tmpcurrent + 1 : tmpcurrent - 1;

            // remove focus class if any..
            this._removeFocus();

            // add class focus - track which option we are navigating
            classie.add(this.selOpts[this.preSelCurrent], 'cs-focus');

            // add focus for aria support
            this.selOpts[this.preSelCurrent].setAttribute("tabindex", "0");
            this.selOpts[this.preSelCurrent].focus();

        }
    }

    /**
     * open/close select
     * when opened show the default placeholder if any
     */
    SelectFx.prototype._toggleSelect = function () {
        // remove focus class if any..
        this._removeFocus();

        if (this._isOpen()) {
            if (this.current !== -1) {
                // update placeholder text
                //this.selPlaceholder.textContent = this.selOpts[this.current].textContent;
                this.selPlaceholder.textContent = this.el.value;

                // add focus to placeholder for screen reader to see the selection that was made
                this.selPlaceholder.setAttribute("tabindex", "0");
                this.selPlaceholder.focus();
            }
            classie.remove(this.selEl, 'cs-active');
            $(this.selEl.children[0]).attr('aria-expanded', 'false');
        }
        else {
            if (this.hasDefaultPlaceholder && this.options.stickyPlaceholder) {
            }
            classie.add(this.selEl, 'cs-active');
            $(this.selEl.children[0]).attr('aria-expanded', 'true');

            if (typeof this.current !== "undefined" && this.current !== -1) {
                this.preSelCurrent = this.current;
                $(this.selOpts[this.current]).eq(0).focus();
                classie.add($(this.selOpts[this.current])[0], 'cs-focus');
            } else if (typeof this.preSelCurrent !== "undefined" && this.preSelCurrent !== -1) {
                classie.add($(this.selOpts[this.preSelCurrent])[0], 'cs-focus');
                $(this.selOpts[this.preSelCurrent]).eq(0).focus();
            } else {
                this._navigateOpts('next');
                $(this.selEl).find('li').eq(0).focus();
                classie.add($(this.selEl).find('li').eq(0)[0], 'cs-focus');
            }
        }
    }

    /**
     * change option - the new value is set
     */

    SelectFx.prototype._changeOption = function (isClickEvt) {
        // if pre selected current (if we navigate with the keyboard)...
        if (typeof this.preSelCurrent != 'undefined' && this.preSelCurrent !== -1) {
            //check the event mouse/change and updated in the custom dropdown value
            if (isClickEvt) {
                this.preSelCurrent = this.current;
            } else {
                this.current = this.preSelCurrent;
            }
        }

        // current option
        var opt = this.selOpts[this.current];

        // update current selected value
        this.selPlaceholder.textContent = opt.textContent;

        // change native select element´s value
        this.el.value = opt.getAttribute('data-value');

        // get data attributes
        this.el.price = opt.getAttribute('data-price');
        this.el.calories = opt.getAttribute('data-calories');
        this.el.isMainList = opt.getAttribute('data-is-main-list');
        this.el.productId = opt.getAttribute('data-submit-product-id');
        

        //get the current product id and value into the hidden calories value
        var productId = opt.getAttribute('data-submit-product-id');        
        $("#caloriesValue-" + productId).text(this.el.calories);
        $("#incrementer-" + productId).find('.btn-decrement').attr({ 'disabled': 'disabled' });
        $("#incrementer-" + productId).find('.btn-incrementer').removeAttr('disabled');
        $("#caloriesValue-" + productId).text();

        var parsingPrice = parseFloat($("#priceValue-" + productId).text());
        $("#price-" + productId).text(parsingPrice);


        // remove class cs-selected from old selected option and add it to current selected option
        var oldOpt = this.selEl.querySelector('li.cs-selected');
        if (oldOpt) {
            classie.remove(oldOpt, 'cs-selected');
        }
        classie.add(opt, 'cs-selected');

        // if there´s a link defined
        if (opt.getAttribute('data-link')) {
            // open in new tab
            if (this.options.newTab) {
                window.open(opt.getAttribute('data-link'), '_blank');
            }
            else {
                window.location = opt.getAttribute('data-link');
            }
        }

        // callback
        this.options.onChange(this.el.value);
    }

    /**
     * returns true if select element is opened
     */
    SelectFx.prototype._isOpen = function (opt) {
        return classie.has(this.selEl, 'cs-active');
    }

    /**
     * removes the focus class from the option
     */
    SelectFx.prototype._removeFocus = function (opt) {
        var focusEl = this.selEl.querySelector('li.cs-focus')
        if (focusEl) {
            classie.remove(focusEl, 'cs-focus');

            // remove tabindex when focus removed
            focusEl.setAttribute("tabindex", "-1");

        }
    }

    /**
     * add to global namespace
     */
    window.SelectFx = SelectFx;

})(window);